import axios from 'axios'

import CryptoJS from 'crypto-js'

export const fetchHash = (data) => {
  const blockSize = 1024 * 1024 * 10
  let wordArray
  const hash = CryptoJS.algo.MD5.create()
  for (let i = 0; i < data.byteLength; i += blockSize) {
    const end = Math.min(i + blockSize, data.byteLength)
    const chunk = data.slice(i, end)
    wordArray = CryptoJS.lib.WordArray.create(Array.from(new Uint8Array(chunk)))
    hash.update(wordArray)
  }

  return hash.finalize().toString()
}
/**
 * 组合使用
 * @param { Object } config  判断条件回调
 * @return { Promise<String> }
 */
export const uploadFileEvent = config => {
	return new Promise((resolve, reject) => {
		const input = document.createElement('input')
		input.type = 'file'
		if (config.accept) {
			input.accept = config.accept
		}
		input.onchange = async () => {
			const file = input.files[0]
			let flag = await beforeUpload(file, config)
			if (flag) {
				if (config?.api) {
					let data = await httpRequest(file, config.api)
					resolve(data)
				} else {
					resolve(file)
				}
			}
		}
		input.oncancel = () => {
			reject()
			throw new Error('取消上传')
		}
		input.onerror = () => {
			reject()
			throw new Error('上传出错~')
		}
		input.click()
	})
}

/**
 * url链接展示文件墙
 * @param { Array } fileUrl url链接数组
 * @return { Array<Object> } 数组
 */
export const fileUrlToBase64 = fileUrl => {
	return fileUrl.map(item => {
		let filename = item.split('/')?.pop() || '*' // 从 URL 中获取文件名
		let blobUrl = URL.createObjectURL(new Blob([''], { type: '' })) // 创建一个 Blob 对象并获取 URL
		return {
			name: filename,
			url: blobUrl
		}
	})
}
/**
 * 上传校验
 * @param { String, Object } file params  二进制 | 回调
 * @return { Boolean }
 */
export const beforeUpload = async (file, params = {}) => {
	const defaultParams = {
		maxSize: 2000,
		suceessCallback: () => {
			return new Promise(resolve => {
				resolve(`成功`)
			})
		},
		errorCallback: () => {
			return new Promise(resolve => {
				resolve(`上传图片大小不能超过${200}KB!`)
			})
		},
		doneCallback: () => {
			return new Promise(resolve => {
				resolve(`完成`)
			})
		}
	}
	const { maxSize, suceessCallback, errorCallback, doneCallback } = Object.assign(params, defaultParams)
	let flag
	if (file.size / 1024 / 1024 > maxSize) {
		errorCallback && (await errorCallback())
		flag = false
	} else {
		suceessCallback && (await suceessCallback())
		flag = true
	}
	doneCallback && doneCallback()
	return flag
}
/**
 *
 * @param { String } file  二进制
 * @return { Promise }
 */
export function readBlobAsArrayBuffer(file) {
	return new Promise(resolve => {
		const reader = new window.FileReader()
		reader.onload = event => resolve(event.target.result)
		reader.readAsArrayBuffer(file)
	})
}
/**
 * 上传方法
 * @param { String } file  二进制
 * @return { Promise }
 */
export const httpRequest = async (file, api) => {
	let rf = await readBlobAsArrayBuffer(file)
	const MD5 = fetchHash(rf)
	const data = await api({
		file_key: 'file',
		filename: file.name,
		hash: MD5,
		mime_type: file.type,
		size: file.size,
		storage: {
			channel: 'public'
		}
	})
	// await upload('http://10.88.18.164:30000/api/v2/storage', {
	// 	file_key: 'file',
	// 	filename: file.name,
	// 	hash: MD5,
	// 	mime_type: file.type,
	// 	size: file.size,
	// 	storage: {
	// 		channel: 'public'
	// 	}
	// })
	let fileUrl
	if (file.size / 1024 / 1024 > 2000) {
		let form = new FormData()
		form.append('file', file.file)
		fileUrl = await uploadFileForm(data.uri, form, {
			...data.headers
		})
	} else {
		fileUrl = await uploadFile(data.uri, rf, {
			...data.headers
		})
	}
	return fileUrl
}

/**
 * 引入axios调用
 */
// const upload = async (url, args) => {
// 	let res = await axios.post(url, args, {
// 		headers: {
// 			// 暂时写死token
// 			Authorization:
// 				'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiZDJiNjkyNzA5MDNjMmU0ZmRkMzI1YzQzNDkzYjY0YWNhN2U0OGYxY2JjMjgxNDkwOGIxNGM5ODhiOTQxOGJlYTQyMjMwYzdjNzg4NTcwOTIiLCJpYXQiOjE2ODIyMTY3MDAuNjQwMDg0LCJuYmYiOjE2ODIyMTY3MDAuNjQwMDg3LCJleHAiOjE2ODc0MDA3MDAuNTk2NjAxLCJzdWIiOiIxIiwic2NvcGVzIjpbIioiXX0.qdIyAV-z0Hto59SN1yUUO0irD36slDpneffyCGm86VPFSyOdIiVxIIAJba6FfUAP1xBrlzuz0A-loGxpyTvgaZ_BJKIOcJOVeePAXeDymgBMILlC-vP7ByIco9UyJG1K_WZMtbtipn-69qhOXRiMxwoNO46ZN3lq0BiAaoDQWXdkCndE1AqA6mQBAGfDxEdyg8hBW0YgNOADgB09giUea1S-nrj8sSm_Myvm7Q-QesSUJQnl1y2kWzDQaLf-ffKuXJum7Wcx-0mqO3yVmJoetVq4KSVapirMpYhq4HXhlRztb62Qngj-EbcG4kJGA4KYWjXUOCT9t6zel9hLB8bkjrOimStq1dVRicj_EbXvOuzhOY3vqjIF0U7JEK_mMsKHD8C46EUEHiGOFX5QSUEUQPJ6vIePsBO7d6FJM8N7aQpsXP1le6uhFh8YK6WEJT-L9NJxvtWJQ8UmkIBQRRDRMOH8DiaRmOtUj4TY11OccA9hlArBbEOSYbHCJN22sN2Mdgv4gAwFUGZzotqN2AzbPffwJqTIeY8tyuxRshT0no41ybzBqbY-0zVyhSQPEfDxgHvV8OINymaph1_o7v1A9YysMzXvYbz3xINVxdSJUc-xfCCrliSpNLm1EpBrxChjwlM0hM0RJie3x8pGl-XrxarWBTSwtuBCBimPpPUnhPM'
// 		}
// 	})
// 	return res.data
// }
const uploadFileForm = async (url, args, config) => {
	let res = await axios.post(url, args, {
		headers: {
			'Content-Type': 'multipart/form-data',
			...config
		}
	})
	return res.data
}
const uploadFile = async (url, args, config) => {
	let res = await axios.put(url, args, {
		headers: {
			'Content-Type': 'multipart/form-data',
			...config
		}
	})
	return res.data
}
